// delReporting/actions.js

import { getDelLists } from "../../../api/DelApi";
import { delReportsListsInitialState } from "./delListsDelReportsListsState";
import { filtersInitialState } from "../../shared/filters/filtersState";
export const makeDelReportsListsActions = (set, get) => ({
  setReportsPage: ({ currentPage, pageSize }) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        delReportsLists: {
          ...s.delLists.delReportsLists,
          currentPage,
          pageSize: pageSize ?? s.delLists.delReportsLists.pageSize,
        },
      },
    })),

  setReportsPageSize: (pageSize) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        delReportsLists: {
          ...s.delLists.delReportsLists,
          pageSize,
          currentPage: 1,
        },
      },
    })),

  setSelectedReport: (report) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        delReportsLists: {
          ...s.delLists.delReportsLists,
          selectedReport: report,
        },
      },
    })),

  toggleSelectedReport: (reportId) =>
    set((s) => {
      const current = s.delLists.delReportsLists.selectedReportIds || [];
      const exists = current.includes(reportId);
      const next = exists
        ? current.filter((i) => i !== reportId)
        : [...current, reportId];
      return {
        delLists: {
          ...s.delLists,
          delReportsLists: {
            ...s.delLists.delReportsLists,
            selectedReportIds: next,
          },
        },
      };
    }),

  setSelectedReportIds: (reportIds) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        delReportsLists: {
          ...s.delLists.delReportsLists,
          selectedReportIds: reportIds,
        },
      },
    })),

  clearSelectedReportIds: () =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        delReportsLists: {
          ...s.delLists.delReportsLists,
          selectedReportIds: [],
        },
      },
    })),

  resetDelReportsLists: () =>
    set((s) => ({
      delLists: { ...s.delLists, delReportsLists: delReportsListsInitialState },
    })),

  fetchDelReportsPage: async (overrideFilters) => {
    const {
      delLists: {
        delReportsLists: { currentPage, pageSize, filters, tableType },
      },
    } = get();
    const activeFilters = overrideFilters || filters || filtersInitialState();

    set((s) => ({
      delLists: {
        ...s.delLists,
        delReportsLists: {
          ...s.delLists.delReportsLists,
          loading: true,
          error: null,
        },
      },
    }));

    try {
      // Map reporting-specific UI keys to backend expected names
      const mappedFilters = { ...activeFilters };
      if (mappedFilters.delStatus !== undefined) {
        mappedFilters.status = mappedFilters.delStatus;
      }
      const r = await getDelLists(
        null,
        tableType,
        currentPage,
        pageSize,
        mappedFilters
      );
      set((s) => ({
        delLists: {
          ...s.delLists,
          delReportsLists: {
            ...s.delLists.delReportsLists,
            loading: false,
            items: r.del_list,
            totalCount: r.total_count,
            needsUpdate: false,
            selectedReport: null,
            hasMore: currentPage * pageSize < (r.total_count || 0),
          },
        },
      }));
    } catch (err) {
      console.error("Failed to fetch reports page:", err);
      set((s) => ({
        delLists: {
          ...s.delLists,
          delReportsLists: {
            ...s.delLists.delReportsLists,
            loading: false,
            error: err.message,
          },
        },
      }));
    }
  },

  loadMoreDelReports: async () => {
    const next = (get().delLists.delReportsLists.currentPage || 1) + 1;
    set((s) => ({
      delLists: {
        ...s.delLists,
        delReportsLists: {
          ...s.delLists.delReportsLists,
          currentPage: next,
        },
      },
    }));
    await get().delListsActions.fetchDelReports();
  },
});
